import { EditSummaryTrowser } from '@/modules/documents/EditSummaryTrowser/EditSummaryTrowser';
import { AnnotatedPDFViewerProvider } from '@/modules/pdf/PDFViewer/AnnotatedPDFViewer/context/AnnotatedPDFViewer.provider';

import { ReviewDocumentSummary } from './hooks/useReviewDocumentSummary';

export interface ReviewDocumentSummaryTrowserProps {
  isOpen: boolean;
  onClose: () => void;
  documentSummary: ReviewDocumentSummary;
}

export function ReviewDocumentSummaryTrowser({
  isOpen,
  onClose,
  documentSummary,
}: ReviewDocumentSummaryTrowserProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <AnnotatedPDFViewerProvider
      showCopyCitationsButton
      showCitations
      documentId={documentSummary.id}
    >
      <EditSummaryTrowser
        isOpen={isOpen}
        onClose={onClose}
        documentId={documentSummary.id}
        documentSummary={documentSummary.documentSummary}
      />
    </AnnotatedPDFViewerProvider>
  );
}
